exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-dialog[data-v-0663e1f3] .el-dialog__body{padding-top:5px;padding-bottom:10px;max-height:calc(100vh - 250px);overflow-y:auto}.device-add-btn[data-v-0663e1f3]{width:505px;height:36px;line-height:36px;text-align:center;color:#8c939d;border:1px dashed #d9d9d9;border-radius:4px;margin-top:10px}.device-add-btn .device-plus-icon[data-v-0663e1f3]{font-size:12px;margin-right:5px}.device-add-btn[data-v-0663e1f3]:hover{cursor:pointer;color:#409EFF;border-color:#409EFF}\n", ""]);

// exports
